import { FC, useEffect, useState } from 'react'
import Loader from './Loader/Loader'

const ServerRenderLoader: FC = ({ children }) => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return <Loader loading={!mounted}>{children}</Loader>
}

export default ServerRenderLoader
